<template>
    <div class="row mb-3 px-3">
        <div class="col-3 py-2 bread-nav d-flex align-items-center facility-link rounded-left">
            <a :href="'/facilities/'+ assessmentCycle.facility_id">{{ facilityName }}</a>
        </div>
        <div class="col-2 bread-nav d-flex align-items-center">
            {{ classroomName }}
        </div>
        <div class="col-7 py-2 bread-nav d-flex justify-content-center align-items-center rounded-right">
            <a :href="'/assessment-cycle-stage?stage=general_info&assessment_cycle_id='+ assessmentCycle.id" 
               class="mr-3 btn btn-sm"
               :class="cycleStage == 'General Info' ? 'btn-light' : 'btn-secondary'"
            >General Info</a>
            <a :href="'/assessment-cycle-stage?stage=initial&assessment_cycle_id='+ assessmentCycle.id" 
               class="mr-3 btn btn-sm"
               :class="cycleStage == 'Initial Assessment' ? 'btn-light' : 'btn-secondary'"
            >Initial Assessment</a>
            <a :href="'/assessment-cycle-stage?stage=qi_plan&assessment_cycle_id='+ assessmentCycle.id" 
               class="mr-3 btn btn-sm"
               :class="cycleStage == 'QI Plan' ? 'btn-light' : 'btn-secondary'"
            >QI Plan</a>
            <a :href="'/assessment-cycle-stage?stage=followup&assessment_cycle_id='+ assessmentCycle.id" 
               class="mr-3 btn btn-sm"
               :class="cycleStage == 'Follow-up Assessment' ? 'btn-light' : 'btn-secondary'"
            >Follow-up Assessment</a>
            <a :href="'/assessment-cycle-stage?stage=summary&assessment_cycle_id='+ assessmentCycle.id" 
               class="btn btn-sm"
               :class="cycleStage == 'Assessment Summary' ? 'btn-light' : 'btn-secondary'"
            >Summary</a>
        </div>
    </div>
</template>

<style scoped>
.bread-nav {
    background-color: #e9ecef;
}
.facility-link {
  line-height: 1.2;
}
</style>

<script>
    export default {
        name: "Breadcrumb Navbar",

        props: {
            assessmentCycle: Object,
            facilityName: String,
            classroomName: String,
            cycleStage: String
        }
    }
</script>
